import { Identifier } from "../../core";
export class ProductInstanceTrackingId extends Identifier {
    constructor(id) {
        super("ProductInstanceTrackingId", id);
    }
}
